import { createActionWithPayload } from './utils';

export const ACTIONS = {
  UPDATE_FEEL_CHECK: 'UPDATE_FEEL_CHECK',
} as const;

export interface IFeelCheckPayload {
  feelCheckCompletedCount?: number;
  currentFeelCheckSenseSetNumber?: number;
  currentFeelCheckBodySetNumber?: number;
  currentFeelCheckCompletedDate?: number;
}

export const updateFeelCheck = createActionWithPayload<
  typeof ACTIONS.UPDATE_FEEL_CHECK,
  IFeelCheckPayload
>(ACTIONS.UPDATE_FEEL_CHECK);
